"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNoResultsCell = exports.StyledBodyCell = exports.StyledBodyRow = exports.VisuallyHidden = exports.stickyStyle = exports.baseStyle = exports.borderStyle = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const borderStyle = (props) => `
  ${(0, ui_theme_1.fromTheme)('border_width')(props)} ${(0, ui_theme_1.fromTheme)('border_style')(props)}
    ${(0, ui_theme_1.fromTheme)('color_border')(props)};
`;
exports.borderStyle = borderStyle;
exports.baseStyle = `
  background-color: #fff;
  border-spacing: 0;
  border-collapse: separate;
`;
exports.stickyStyle = `
  position: sticky;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
`;
exports.VisuallyHidden = (0, styled_1.default)('span') `
  border: 0;
  clip: rect(0 0 0 0);
  height: auto;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
`;
exports.StyledBodyRow = (0, styled_1.default)('tr') `
  background-color: inherit;
  ${(props) => props.disableHoverStyles
    ? ''
    : `&:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')(props)};
  }
  `};
  ${(props) => props.striped
    ? `background-color: ${(0, ui_theme_1.fromTheme)('color_background_secondary')(props)};`
    : ''}
  ${(props) => props.hideHeaderRow
    ? `td { border-top: ${(0, exports.borderStyle)(props)}; }`
    : `
      &:not(:first-of-type) {
        td {
          border-top: ${(0, exports.borderStyle)(props)};
        }
      }`}
  ${(props) => `&:focus {
      background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')(props)};
      outline: none;
    }
  `};
`;
exports.StyledBodyCell = (0, styled_1.default)('td') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  background-color: inherit;
`;
exports.StyledNoResultsCell = (0, styled_1.default)(exports.StyledBodyCell) `
  text-align: center;
`;
//# sourceMappingURL=styles.js.map